"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing Account operations. */
var AccountImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class Account class.
   * @param client Reference to the service client
   */
  function AccountImpl(client) {
    (0, _classCallCheck2["default"])(this, AccountImpl);
    this.client = client;
  }
  /** @param options The options parameters. */


  (0, _createClass2["default"])(AccountImpl, [{
    key: "login",
    value: function login(options) {
      var operationArguments = {
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, loginOperationSpec);
    }
    /** @param options The options parameters. */

  }, {
    key: "logout",
    value: function logout(options) {
      var operationArguments = {
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, logoutOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param options The options parameters.
     */

  }, {
    key: "userInfo",
    value: function userInfo(options) {
      var operationArguments = {
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, userInfoOperationSpec);
    }
  }]);
  return AccountImpl;
}(); // Operation Specifications


exports.AccountImpl = AccountImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var loginOperationSpec = {
  path: "/Account/signin",
  httpMethod: "GET",
  responses: {
    200: {}
  },
  queryParameters: [Parameters.returnUrl],
  urlParameters: [Parameters.$host],
  serializer: serializer
};
var logoutOperationSpec = {
  path: "/Account/signout",
  httpMethod: "GET",
  responses: {
    200: {}
  },
  urlParameters: [Parameters.$host],
  serializer: serializer
};
var userInfoOperationSpec = {
  path: "/Account/session-info",
  httpMethod: "GET",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host],
  serializer: serializer
};